import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { apiService } from "../../services/apiService";

export const fetchCeoNote = createAsyncThunk(
  "ceo/fetchCeoNote",
  async (_, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("token");
      const response = await apiService.get("/ceo-note", {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      });

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const fetchTermsandPolicy = createAsyncThunk(
  "ceo/fetchTermsandPolicy",
  async (_, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("token");
      const response = await apiService.get("/termsandpolicy", {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const updateCondition = createAsyncThunk(
  "ceo/updateCondition",
  async (formData, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("token");
      const response = await apiService.post(
        "/admin/update/conditions",
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const updatePrivacy = createAsyncThunk(
  "ceo/updatePrivacy",
  async (formData, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("token");
      const response = await apiService.post(
        "/admin/update/privacy",
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const addCeoNote = createAsyncThunk(
  "ceo/addCeoNote",
  async (formData, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("token");
      const response = await apiService.post(
        "/admin/update/ceo-note",
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const setAutoEmail = createAsyncThunk(
  "ceo/setAutoEmail",
  async (formData, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("token");
      const response = await apiService.post(
        "/admin/auto-email-set",
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const fetchAutoMessage = createAsyncThunk(
  "ceo/fetchAutoMessage",
  async (_, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("token");
      const response = await apiService.get("/admin/auto-message", {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

const ceoSlice = createSlice({
  name: "ceo",
  initialState: {
    ceoNotes: [],
    termsandPolicies: [],
    autoMessage: [],
    status: "idle",
    error: null,
    autoEmailStatus: "idle",
    autoMessageStatus: "idle",
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchCeoNote.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(fetchCeoNote.fulfilled, (state, action) => {
        state.status = "success";
        state.ceoNotes = action.payload.data;
      })

      .addCase(fetchCeoNote.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })
      .addCase(fetchTermsandPolicy.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(fetchTermsandPolicy.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.termsandPolicies = action.payload.data;
      })

      .addCase(fetchTermsandPolicy.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })
      .addCase(addCeoNote.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(addCeoNote.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.ceoNotes = [action.payload];
      })
      .addCase(addCeoNote.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })
      .addCase(setAutoEmail.pending, (state) => {
        state.autoEmailStatus = "loading";
      })
      .addCase(setAutoEmail.fulfilled, (state, action) => {
        state.autoEmailStatus = "succeeded";
        state.ceoNotes = action.payload;
      })
      .addCase(setAutoEmail.rejected, (state, action) => {
        state.autoEmailStatus = "failed";
        state.error = action.payload;
      })
      .addCase(fetchAutoMessage.pending, (state) => {
        state.autoMessageStatus = "loading";
      })
      .addCase(fetchAutoMessage.fulfilled, (state, action) => {
        state.autoMessageStatus = "succeeded";
        state.autoMessage = action.payload;
      })
      .addCase(fetchAutoMessage.rejected, (state, action) => {
        state.autoMessageStatus = "failed";
        state.error = action.payload;
      })
      .addCase(updateCondition.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(updateCondition.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.error = null;
      })
      .addCase(updateCondition.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })
      .addCase(updatePrivacy.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(updatePrivacy.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.error = null;
      })
      .addCase(updatePrivacy.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      });
  },
});

export default ceoSlice.reducer;
